import { render, staticRenderFns } from "./details.vue?vue&type=template&id=7fcc0c25&scoped=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc0c25",
  null
  
)

export default component.exports